import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Card, Modal, Form } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import * as XLSX from "xlsx";
import { useParams } from 'react-router-dom';
import Header from "../Header";

const TicketQueries = () => {
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [user_Description, setUserRemarks] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);  // Changed to an array to handle multiple files
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const id = localStorage.getItem('userId');
  const sessionName = localStorage.getItem('userName');
  const { ticket_id } = useParams();
  
  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://apiaksharaconnect.aksharafinalytics.in/VQuery/${ticket_id}`
        );
        if (!response.ok) throw new Error("Network response was not ok");

        const result = await response.json();
      
        setData(result || []);
        console.log(result);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  
  // Initialize DataTable
  useEffect(() => {
    if (tableRef.current && data.length > 0) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true,
        paging: true,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
        columnDefs: [
          { targets: 0, responsivePriority: 1 },
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
        ],
      });

      return () => {
        table.destroy();
      };
    }
  }, [data]);

  // Export to Excel
  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data to export!");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "data");
    XLSX.writeFile(wb, "data_List.xlsx");
  };

  // Open modal for reply
  const openModal = (request) => {
    setSelectedRequest(request);
    console.log(request);
    setIsModalOpen(true);
  };

  // Handle form submit (reply with remarks and multiple files)
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    

    const recordId = selectedRequest.id;
    console.log(recordId);
    setIsSubmitting(true); // Start submission process

    const formData = new FormData();
    formData.append("user_Description", user_Description);

    // Append the first file from selectedFiles to the form data
    if (selectedFiles && selectedFiles.length > 0) {
        const file = selectedFiles[0]; // Only get the first file
        console.log('File being appended:', file);
        formData.append('file', file); // Append the file to FormData
    }

    try {
        // Make the POST request to the server
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/updateticket/${recordId}`, {
            method: 'POST',
            body: formData,
        });

        // Log the full response for debugging purposes
        const res = await response.json();
        
        console.log(res);
        // Check if the response is success
        if (res.status === 'success') {
            setSuccessMessage(res.message); 
            setUserRemarks(''); 
            setSelectedFiles([]);
            setIsModalOpen(false);
            setTimeout(() => {
              window.location.reload(); 
          }, 3000);
        } else {
            // Handle error based on response
            setError(res.message);
            console.error('Error message from server:', res.message);
        }
    } catch (error) {
        setError('An error occurred while uploading the files.'); // Handle general errors
        console.error('Error during fetch:', error); // Log the error to console for debugging
    } finally {
        setIsSubmitting(false);  // Stop submission process
    }
};



  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <>
      <Header />
      <Container fluid className="mt-4">
        <Card className="shadow">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h4>Ticket Queries</h4>
            <Button variant="success" onClick={exportToExcel}>
              Export to Excel
            </Button>
          </Card.Header>
          <Card.Body>
            {error && <div className="alert alert-danger">{error}</div>}
            {successMessage && <div className="alert alert-success">{successMessage}</div>}

            <div className="table-responsive">
              <table ref={tableRef} className="table table-striped table-bordered display nowrap" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Ticket Id</th>
                    <th>Query</th>
                    <th>Quired Doc</th>
                    <th>Response</th>
                    <th>Reply Doc</th>
                    <th>Date</th>
                    <th>Reply</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length > 0 ? (
                    data.map((data, index) => (
                      <tr key={`${data.id}-${index}`}>
                        <td>{index + 1}</td>
                        <td className="text-danger">{data.ticket_id || "N/A"}</td>
                        <td>{data.emp_query || "N/A"}</td>
                        <td>
                            {data.emp_file ? (
                            <a href={`https://apiaksharaconnect.aksharafinalytics.in/${data.emp_file}`} download={data.emp_file || 'N/A'} target='_blank'>
                                <Button variant="warning" size="sm" className="ms-2">
                                <FontAwesomeIcon icon={faDownload} /> Download
                                </Button>
                            </a>
                            ) : (
                            <span>N/A</span>
                            )}
                        </td>
                        <td>{data.user_Description || "N/A"}</td>
                        <td>
                          {data.file_path ? (
                            <a href={`https://apiaksharaconnect.aksharafinalytics.in/${data.file_path}`} download={data.file_path || 'N/A'} target="_blank">
                              <Button variant="warning" className="ms-2 p-1 m-1">
                                <FontAwesomeIcon icon={faDownload} />
                                 Documents
                              </Button>
                            </a>
                          ) : (
                            <span>N/A</span>
                          )}
                        </td>
                        <td>{data.doa || "N/A"}</td> 
                        <td>{data.reply_date || "N/A"}</td>                        
                        <td> 
                            <Button variant="primary" onClick={() => openModal(data)}   disabled={data.status === "close" || data.user_Description !== null}> Reply</Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card.Body>
        </Card>
      </Container>

      {/* Modal */}
      {isModalOpen && (
        <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Reply to Request</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleFormSubmit}>
              <input id="task_uniqueid" className="form-control" type="hidden" value={selectedRequest?.id || ''} readOnly />

              <Form.Group className="mb-3">
                <Form.Label>Remarks</Form.Label>
                <Form.Control as="textarea" rows={3} value={user_Description} onChange={(e) => setUserRemarks(e.target.value)} required />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Upload Files</Form.Label>
                <Form.Control type="file" name="file" onChange={(e) => setSelectedFiles([...e.target.files])} />
              </Form.Group>

              <Button type="submit" variant="primary" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit Reply'}
              </Button>
              
            </Form>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default TicketQueries;
